
const cart = [
    {
        path: '/cart',
        name: 'cart',
        redirect: '/cart-main',
        meta: { breadcrumb: '购物车', requiresAuth: true },
        component: () => import('@/views/cart/cart.vue'),
        children: [
            {
                path: '/cart-main',
                name: 'cart-main',
                meta: { breadcrumb: '购物车列表', requiresAuth: true },
                component: () => import('@/views/cart/pages/cart-main.vue')
            },
            {
                path: '/orders',
                name: 'orders',
                meta: { breadcrumb: '确认订单', requiresAuth: true },
                component: () => import('@/views/cart/pages/orders.vue')
            }, {
                path: '/pay',
                name: 'pay',
                meta: { breadcrumb: '支付', requiresAuth: true },
                component: () => import('@/views/cart/pages/pay.vue')
            }
        ]
    }
]

export default cart

